export interface CryptoPairConfig {
  symbol: string;
  name: string;
  type: 'crypto';
  active: boolean;
  priority: 'high' | 'normal';
}

export const TOP_CRYPTO_PAIRS: CryptoPairConfig[] = [
  { symbol: 'BTCUSDT', name: 'Bitcoin', type: 'crypto', active: true, priority: 'high' },
  { symbol: 'ETHUSDT', name: 'Ethereum', type: 'crypto', active: true, priority: 'high' },
  { symbol: 'SOLUSDT', name: 'Solana', type: 'crypto', active: true, priority: 'high' },
  { symbol: 'BNBUSDT', name: 'BNB', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'XRPUSDT', name: 'XRP', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'DOGEUSDT', name: 'Dogecoin', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'ADAUSDT', name: 'Cardano', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'AVAXUSDT', name: 'Avalanche', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'LINKUSDT', name: 'Chainlink', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'DOTUSDT', name: 'Polkadot', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'NEARUSDT', name: 'NEAR Protocol', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'LTCUSDT', name: 'Litecoin', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'UNIUSDT', name: 'Uniswap', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'SUIUSDT', name: 'Sui', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'APTUSDT', name: 'Aptos', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'ARBUSDT', name: 'Arbitrum', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'OPUSDT', name: 'Optimism', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'INJUSDT', name: 'Injective', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'MATICUSDT', name: 'Polygon', type: 'crypto', active: true, priority: 'normal' },
  { symbol: 'ATOMUSDT', name: 'Cosmos', type: 'crypto', active: true, priority: 'normal' },
];

export const CFD_INSTRUMENTS = [
  // Forex Pairs - Majors
  { symbol: 'EUR/USD', name: 'Euro/US Dollar', type: 'forex', active: true },
  { symbol: 'GBP/USD', name: 'British Pound/US Dollar', type: 'forex', active: true },
  { symbol: 'AUD/USD', name: 'Australian Dollar/US Dollar', type: 'forex', active: true },
  { symbol: 'NZD/USD', name: 'New Zealand Dollar/US Dollar', type: 'forex', active: true },
  { symbol: 'USD/JPY', name: 'US Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'USD/CHF', name: 'US Dollar/Swiss Franc', type: 'forex', active: true },
  { symbol: 'USD/CAD', name: 'US Dollar/Canadian Dollar', type: 'forex', active: true },

  // Forex Pairs - Crosses (Minors)
  { symbol: 'EUR/JPY', name: 'Euro/Japanese Yen', type: 'forex', active: true },
  { symbol: 'EUR/GBP', name: 'Euro/British Pound', type: 'forex', active: true },
  { symbol: 'EUR/AUD', name: 'Euro/Australian Dollar', type: 'forex', active: true },
  { symbol: 'EUR/CHF', name: 'Euro/Swiss Franc', type: 'forex', active: true },
  { symbol: 'EUR/CAD', name: 'Euro/Canadian Dollar', type: 'forex', active: true },
  { symbol: 'EUR/NZD', name: 'Euro/New Zealand Dollar', type: 'forex', active: true },
  { symbol: 'GBP/JPY', name: 'British Pound/Japanese Yen', type: 'forex', active: true },
  { symbol: 'GBP/AUD', name: 'British Pound/Australian Dollar', type: 'forex', active: true },
  { symbol: 'GBP/CHF', name: 'British Pound/Swiss Franc', type: 'forex', active: true },
  { symbol: 'GBP/CAD', name: 'British Pound/Canadian Dollar', type: 'forex', active: true },
  { symbol: 'GBP/NZD', name: 'British Pound/New Zealand Dollar', type: 'forex', active: true },
  { symbol: 'AUD/CAD', name: 'Australian Dollar/Canadian Dollar', type: 'forex', active: true },
  { symbol: 'AUD/CHF', name: 'Australian Dollar/Swiss Franc', type: 'forex', active: true },
  { symbol: 'AUD/JPY', name: 'Australian Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'AUD/NZD', name: 'Australian Dollar/New Zealand Dollar', type: 'forex', active: true },
  { symbol: 'NZD/JPY', name: 'New Zealand Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'NZD/CHF', name: 'New Zealand Dollar/Swiss Franc', type: 'forex', active: true },
  { symbol: 'NZD/CAD', name: 'New Zealand Dollar/Canadian Dollar', type: 'forex', active: true },
  { symbol: 'CAD/JPY', name: 'Canadian Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'CAD/CHF', name: 'Canadian Dollar/Swiss Franc', type: 'forex', active: true },
  { symbol: 'CHF/JPY', name: 'Swiss Franc/Japanese Yen', type: 'forex', active: true },

  // Forex Pairs - Popular Exotics
  { symbol: 'USD/TRY', name: 'US Dollar/Turkish Lira', type: 'forex', active: true },
  { symbol: 'EUR/TRY', name: 'Euro/Turkish Lira', type: 'forex', active: true },
  { symbol: 'USD/ZAR', name: 'US Dollar/South African Rand', type: 'forex', active: true },
  { symbol: 'USD/HKD', name: 'US Dollar/Hong Kong Dollar', type: 'forex', active: true },
  { symbol: 'USD/SGD', name: 'US Dollar/Singapore Dollar', type: 'forex', active: true },
  { symbol: 'USD/DKK', name: 'US Dollar/Danish Krone', type: 'forex', active: true },
  { symbol: 'USD/NOK', name: 'US Dollar/Norwegian Krone', type: 'forex', active: true },
  { symbol: 'USD/SEK', name: 'US Dollar/Swedish Krona', type: 'forex', active: true },
  { symbol: 'USD/PLN', name: 'US Dollar/Polish Zloty', type: 'forex', active: true },
  { symbol: 'USD/HUF', name: 'US Dollar/Hungarian Forint', type: 'forex', active: true },
  { symbol: 'USD/CZK', name: 'US Dollar/Czech Koruna', type: 'forex', active: true },
  { symbol: 'USD/MXN', name: 'US Dollar/Mexican Peso', type: 'forex', active: true },
  { symbol: 'USD/BRL', name: 'US Dollar/Brazilian Real', type: 'forex', active: true },
  { symbol: 'USD/CNH', name: 'US Dollar/Chinese Yuan Offshore', type: 'forex', active: true },
  { symbol: 'USD/THB', name: 'US Dollar/Thai Baht', type: 'forex', active: true },
  { symbol: 'USD/IDR', name: 'US Dollar/Indonesian Rupiah', type: 'forex', active: true },

  // Forex Pairs - Asian & Pacific
  { symbol: 'AUD/SGD', name: 'Australian Dollar/Singapore Dollar', type: 'forex', active: true },
  { symbol: 'AUD/HKD', name: 'Australian Dollar/Hong Kong Dollar', type: 'forex', active: true },
  { symbol: 'NZD/SGD', name: 'New Zealand Dollar/Singapore Dollar', type: 'forex', active: true },
  { symbol: 'SGD/JPY', name: 'Singapore Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'HKD/JPY', name: 'Hong Kong Dollar/Japanese Yen', type: 'forex', active: true },
  { symbol: 'USD/TWD', name: 'US Dollar/Taiwan Dollar', type: 'forex', active: true },
  { symbol: 'USD/KRW', name: 'US Dollar/South Korean Won', type: 'forex', active: true },
  { symbol: 'USD/INR', name: 'US Dollar/Indian Rupee', type: 'forex', active: true },
  { symbol: 'USD/PHP', name: 'US Dollar/Philippine Peso', type: 'forex', active: true },
  { symbol: 'USD/MYR', name: 'US Dollar/Malaysian Ringgit', type: 'forex', active: true },

  // Forex Pairs - Scandinavian & Europe
  { symbol: 'EUR/SEK', name: 'Euro/Swedish Krona', type: 'forex', active: true },
  { symbol: 'EUR/NOK', name: 'Euro/Norwegian Krone', type: 'forex', active: true },
  { symbol: 'EUR/DKK', name: 'Euro/Danish Krone', type: 'forex', active: true },
  { symbol: 'EUR/PLN', name: 'Euro/Polish Zloty', type: 'forex', active: true },
  { symbol: 'EUR/HUF', name: 'Euro/Hungarian Forint', type: 'forex', active: true },
  { symbol: 'EUR/CZK', name: 'Euro/Czech Koruna', type: 'forex', active: true },

  // Forex Pairs - Middle East
  { symbol: 'USD/SAR', name: 'US Dollar/Saudi Riyal', type: 'forex', active: true },
  { symbol: 'USD/AED', name: 'US Dollar/UAE Dirham', type: 'forex', active: true },
  { symbol: 'USD/QAR', name: 'US Dollar/Qatari Riyal', type: 'forex', active: true },
  { symbol: 'USD/ILS', name: 'US Dollar/Israeli Shekel', type: 'forex', active: true },
  { symbol: 'EUR/ILS', name: 'Euro/Israeli Shekel', type: 'forex', active: true },

  // Forex Pairs - Latin America
  { symbol: 'USD/CLP', name: 'US Dollar/Chilean Peso', type: 'forex', active: true },
  { symbol: 'USD/COP', name: 'US Dollar/Colombian Peso', type: 'forex', active: true },
  { symbol: 'USD/PEN', name: 'US Dollar/Peruvian Sol', type: 'forex', active: true },

  // Forex Pairs - Africa
  { symbol: 'EUR/ZAR', name: 'Euro/South African Rand', type: 'forex', active: true },
  { symbol: 'GBP/ZAR', name: 'British Pound/South African Rand', type: 'forex', active: true },
  { symbol: 'AUD/ZAR', name: 'Australian Dollar/South African Rand', type: 'forex', active: true },

  // Approved Commodities Only
  // Working Commodities (from your WebSocket test)
  { symbol: 'XAG/USD', name: 'Silver/USD', type: 'commodity', active: true },
  { symbol: 'NATGAS/USD', name: 'Natural Gas', type: 'commodity', active: true },
  { symbol: 'BCO/USD', name: 'Brent Crude', type: 'commodity', active: true },
  { symbol: 'WTICO/USD', name: 'WTI Crude Oil', type: 'commodity', active: true },
  { symbol: 'XPT/USD', name: 'Platinum/USD', type: 'commodity', active: true },
  { symbol: 'XAU/USD', name: 'Gold/USD', type: 'commodity', active: true },
  { symbol: 'XPD/USD', name: 'Palladium/USD', type: 'commodity', active: true },
  { symbol: 'CORN/USD', name: 'Corn', type: 'commodity', active: true },
  { symbol: 'WHEAT/USD', name: 'Wheat', type: 'commodity', active: true },
  { symbol: 'SUGAR/USD', name: 'Sugar', type: 'commodity', active: true },

  // Major US Stocks
  { symbol: 'AAPL', name: 'Apple Inc.', type: 'stock', active: true },
  { symbol: 'MSFT', name: 'Microsoft Corporation', type: 'stock', active: true },
  { symbol: 'GOOGL', name: 'Alphabet Inc.', type: 'stock', active: true },
  { symbol: 'AMZN', name: 'Amazon.com Inc.', type: 'stock', active: true },
  { symbol: 'TSLA', name: 'Tesla Inc.', type: 'stock', active: true },
  { symbol: 'META', name: 'Meta Platforms Inc.', type: 'stock', active: true },
  { symbol: 'NFLX', name: 'Netflix Inc.', type: 'stock', active: true },
  { symbol: 'NVDA', name: 'NVIDIA Corporation', type: 'stock', active: true },
  { symbol: 'BA', name: 'Boeing Company', type: 'stock', active: true },
  { symbol: 'JPM', name: 'JPMorgan Chase & Co.', type: 'stock', active: true },
  { symbol: 'GS', name: 'Goldman Sachs', type: 'stock', active: true },
  { symbol: 'BAC', name: 'Bank of America', type: 'stock', active: true },
  { symbol: 'WMT', name: 'Walmart', type: 'stock', active: true },
  { symbol: 'DIS', name: 'Disney', type: 'stock', active: true },
  { symbol: 'CVX', name: 'Chevron', type: 'stock', active: true },

  // More US Stocks
  { symbol: 'AMD', name: 'Advanced Micro Devices', type: 'stock', active: true },
  { symbol: 'INTC', name: 'Intel Corporation', type: 'stock', active: true },
  { symbol: 'ORCL', name: 'Oracle Corporation', type: 'stock', active: true },
  { symbol: 'IBM', name: 'International Business Machines', type: 'stock', active: true },
  { symbol: 'ADBE', name: 'Adobe Inc.', type: 'stock', active: true },
  { symbol: 'PYPL', name: 'PayPal Holdings Inc.', type: 'stock', active: true },
  { symbol: 'UBER', name: 'Uber Technologies Inc.', type: 'stock', active: true },
  { symbol: 'LYFT', name: 'Lyft Inc.', type: 'stock', active: true },
  { symbol: 'PFE', name: 'Pfizer Inc.', type: 'stock', active: true },
  { symbol: 'MRNA', name: 'Moderna Inc.', type: 'stock', active: true },
  { symbol: 'KO', name: 'Coca-Cola Company', type: 'stock', active: true },
  { symbol: 'PEP', name: 'PepsiCo Inc.', type: 'stock', active: true },
  { symbol: 'XOM', name: 'Exxon Mobil Corporation', type: 'stock', active: true },
  { symbol: 'T', name: 'AT&T', type: 'stock', active: true },
  { symbol: 'V', name: 'Visa Inc.', type: 'stock', active: true },
  { symbol: 'MA', name: 'Mastercard Inc.', type: 'stock', active: true },

  // Additional US Stocks
  { symbol: 'CSCO', name: 'Cisco Systems Inc.', type: 'stock', active: true },
  { symbol: 'CRM', name: 'Salesforce Inc.', type: 'stock', active: true },
  { symbol: 'COST', name: 'Costco Wholesale Corporation', type: 'stock', active: true },
  { symbol: 'AVGO', name: 'Broadcom Inc.', type: 'stock', active: true },
  { symbol: 'TXN', name: 'Texas Instruments Inc.', type: 'stock', active: true },
  { symbol: 'QCOM', name: 'Qualcomm Inc.', type: 'stock', active: true },
  { symbol: 'AMAT', name: 'Applied Materials Inc.', type: 'stock', active: true },
  { symbol: 'INTU', name: 'Intuit Inc.', type: 'stock', active: true },
  { symbol: 'SBUX', name: 'Starbucks Corporation', type: 'stock', active: true },
  { symbol: 'MCD', name: 'McDonald\'s Corporation', type: 'stock', active: true },
  { symbol: 'LOW', name: 'Lowe\'s Companies Inc.', type: 'stock', active: true },
  { symbol: 'HD', name: 'Home Depot Inc.', type: 'stock', active: true },
  { symbol: 'CAT', name: 'Caterpillar Inc.', type: 'stock', active: true },
  { symbol: 'HON', name: 'Honeywell International Inc.', type: 'stock', active: true },
  { symbol: 'AMGN', name: 'Amgen Inc.', type: 'stock', active: true },
  { symbol: 'LLY', name: 'Eli Lilly and Company', type: 'stock', active: true },
  { symbol: 'UNH', name: 'UnitedHealth Group Inc.', type: 'stock', active: true },
  { symbol: 'ABT', name: 'Abbott Laboratories', type: 'stock', active: true },
  { symbol: 'CVS', name: 'CVS Health Corporation', type: 'stock', active: true },
  { symbol: 'WFC', name: 'Wells Fargo & Company', type: 'stock', active: true },
  { symbol: 'MS', name: 'Morgan Stanley', type: 'stock', active: true },
  { symbol: 'AXP', name: 'American Express Company', type: 'stock', active: true },
  { symbol: 'BLK', name: 'BlackRock Inc.', type: 'stock', active: true },
  { symbol: 'C', name: 'Citigroup Inc.', type: 'stock', active: true },
  { symbol: 'BK', name: 'Bank of New York Mellon Corp', type: 'stock', active: true },
  { symbol: 'TGT', name: 'Target Corporation', type: 'stock', active: true },
  { symbol: 'NKE', name: 'Nike Inc.', type: 'stock', active: true },
  { symbol: 'SHOP', name: 'Shopify Inc.', type: 'stock', active: true },
  { symbol: 'SNOW', name: 'Snowflake Inc.', type: 'stock', active: true },
  { symbol: 'PLTR', name: 'Palantir Technologies Inc.', type: 'stock', active: true },

  // Global Indices & ETFs
  { symbol: 'CAC', name: 'France CAC 40', type: 'index', active: true },
  { symbol: 'ASX', name: 'Australia ASX 200', type: 'index', active: true },
  { symbol: 'SPY', name: 'SPDR S&P 500 ETF', type: 'index', active: true },
  { symbol: 'QQQ', name: 'NASDAQ 100 ETF', type: 'index', active: true },
  { symbol: 'DIA', name: 'Dow Jones ETF', type: 'index', active: true },
  { symbol: 'IWM', name: 'Russell 2000 ETF', type: 'index', active: true },
  { symbol: 'VTI', name: 'Total US Stock Market ETF', type: 'index', active: true },
  { symbol: 'ARKK', name: 'ARK Innovation ETF', type: 'index', active: true },
  { symbol: 'XLK', name: 'Technology Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLF', name: 'Financial Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLE', name: 'Energy Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLY', name: 'Consumer Discretionary Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLP', name: 'Consumer Staples Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLV', name: 'Health Care Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLI', name: 'Industrial Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLB', name: 'Materials Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'XLU', name: 'Utilities Select Sector SPDR Fund', type: 'index', active: true },
  { symbol: 'IYR', name: 'iShares US Real Estate ETF', type: 'index', active: true },
  { symbol: 'SMH', name: 'VanEck Semiconductor ETF', type: 'index', active: true },
  { symbol: 'SOXX', name: 'iShares Semiconductor ETF', type: 'index', active: true },
  { symbol: 'TLT', name: 'iShares 20+ Year Treasury Bond ETF', type: 'index', active: true },
  { symbol: 'HYG', name: 'iShares iBoxx High Yield Corporate Bond ETF', type: 'index', active: true },
  { symbol: 'GLD', name: 'SPDR Gold Trust', type: 'index', active: true },
  { symbol: 'SLV', name: 'iShares Silver Trust', type: 'index', active: true },
  { symbol: 'BITO', name: 'ProShares Bitcoin Strategy ETF', type: 'index', active: true },
  { symbol: 'SPYD', name: 'SPDR Portfolio S&P 500 High Dividend ETF', type: 'index', active: true },
  { symbol: 'JEPI', name: 'JPMorgan Equity Premium Income ETF', type: 'index', active: true },
  { symbol: 'VOO', name: 'Vanguard S&P 500 ETF', type: 'index', active: true }
];
